import FileTable from "../../../../src/components/UI/FileTable.js";
import React from 'react';
export default {
  FileTable,
  React
};